import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  SuccessIcon,
  JoinTheWaitlistSuccessBgIcon,
} from "@/components/ui/icon";
import { Spinner } from "@/components/ui/modal";
import { iamEmailManager } from "@/manager";
import { useAPIJoinWaitingQueue } from "@/hooks/use-api-join-waiting-queue";
import { useToast } from "@/hooks/use-toast";
import { cn } from "@/utils/cn";
import analytics from "@/utils/analytics";

export const WaitlistButton = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const { handleAPIJoinWaitingQueue } = useAPIJoinWaitingQueue();
  const { showToastByCode } = useToast();

  const handleClick = async () => {
    if (loading || success) {
      return;
    }
    analytics.trackWaitlist({ email: iamEmailManager.get() });
    setLoading(true);
    try {
      await handleAPIJoinWaitingQueue();
      setSuccess(true);
    } catch (error) {
      analytics.trackWaitlistJoinFail({
        reason: error.message,
        email: iamEmailManager.get(),
      });
      showToastByCode(error);
    }
    analytics.trackWaitlistJoinSuccess({ email: iamEmailManager.get() });
    setLoading(false);
  };

  return (
    <div>
      <div className="relative rounded-lg overflow-hidden">
        <button
          type="button"
          className="w-full py-3 rounded-lg text-i-normal text-base bg-white hover:bg-gray-200 font-semibold transition-all flex items-center justify-center border border-gray-300 shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)]"
          onClick={handleClick}
        >
          {loading ? <Spinner /> : t("invite.waitlist_section.join_the_waitlist")}
        </button>
        <div
          className={cn(
            "absolute top-0 left-0 w-full h-full flex items-center justify-center pointer-events-none",
            "opacity-0",
            success && "opacity-100"
          )}
        >
          <JoinTheWaitlistSuccessBgIcon className="absolute -top-1 -left-1 h-[110%]" />
          <div className="absolute flex justify-center items-center gap-2">
            <SuccessIcon className="w-5 h-5" />
            <span className="text-base text-white font-semibold">
              {t("invite.waitlist_section.success")}
            </span>
          </div>
        </div>
      </div>
      {success && (
        <>
          <p className="mt-5 text-xxs text-[rgba(182,160,211,1)] text-center">
            {t("invite.waitlist_section.thanks_for_joining")}
          </p>
          <p className="mt-3 text-xxs text-[rgba(182,160,211,1)] text-center">
            {t("invite.waitlist_section.notify_spot_opens")}
          </p>
        </>
      )}
    </div>
  );
};
